import { Component, ViewChild } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { TeamListComponent } from '../../lib/team-list/team-list.component'

const exampleHtml = `
<div>
  <se-po-team-list personaId="123" (hasResults)=hasResults()>
  </se-po-team-list>
</div>
`

const exampleTypescript = `
import { Component } from '@angular/core'

export class RegistrationListExampleComponent {

  constructor() {
  }

}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-team-list-example',
  template,
  styleUrls: ['./team-list-docs.component.scss'],
  standalone: false,
})
export class TeamListExampleComponent extends SeFeDocsExampleComponent {
  @ViewChild(TeamListComponent) teamList: TeamListComponent
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]


  constructor() {
    super()
  }

  public hasResults(): void {
    this.teamList.listItems = [
      {
        menuOptions: {
          name: '10U Baseball-0',
          sections: [{
            menuItems: [{
              href: '/user/teams',
              text: 'View Team'
            }]
          }]
        },
        subtitle: ['Sept 2023', 'Dec 2024'],
        title: '10U Baseball'
      },
      {
        menuOptions: {
          name: '10U Soccer-1',
          sections: [{
            menuItems: [{
              href: '/user/teams',
              text: 'View Team'
            }]
          }]
        },
        subtitle: ['Sept 2023', 'Aug 2024'],
        title: '10U Soccer'
      }
    ]
  }

}
